import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
  selector: "ds-footer-stepper",
  templateUrl: "./ds-footer-stepper.component.html",
  styleUrls: ["./ds-footer-stepper.component.scss"],
})
export class DsFooterStepperComponent {
  @Input() previousLabel!: string;
  @Input() nextLabel!: string;
  @Input() disabledPrevious: boolean = false;
  @Input() disabledNext: boolean = false;
  @Output() onPrevious = new EventEmitter();
  @Output() onNext = new EventEmitter();

  constructor() {}
}
